export enum MenuBadgeCountKey {
  WAITING_TICKETS = 'waiting-tickets',
  PENDING_CHECKLISTS = 'pending-checklists',
  NEW_TRAININGS = 'new-trainings',
}
